import React from "react";
import { Link2, ExternalLink } from "lucide-react";

interface LinkEmbedProps {
  title: string | null;
  contentUrl: string;
  description?: string | null;
}

export function LinkEmbed({ title, contentUrl, description }: LinkEmbedProps) {
  return (
    <div className="my-6">
      {contentUrl ? (
        <div className="rounded-lg border border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-800">
          <div className="p-6">
            <div className="flex items-start justify-between gap-4">
              <div className="flex items-start gap-4 flex-1">
                {/* Icon Container */}
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-purple-50 to-indigo-100 dark:from-purple-900/20 dark:to-indigo-900/20 flex items-center justify-center">
                    <Link2 className="w-6 h-6 text-purple-600 dark:text-purple-400" />
                  </div>
                </div>

                {/* Content Container */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">
                    {title || "External Link"}
                  </h3>
                  {description && (
                    <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                      {description}
                    </p>
                  )}
                </div>
              </div>

              {/* Visit Link Button - Right Side */}
              <div className="flex-shrink-0">
                <a
                  className="inline-flex items-center gap-2 px-4 py-2 bg-gray-900 hover:bg-gray-800 dark:bg-gray-100 dark:hover:bg-gray-200 text-white dark:text-gray-900 font-medium text-sm rounded-lg transition-all duration-200 shadow-sm hover:shadow"
                  href={contentUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span>View</span>
                  <ExternalLink className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p className="text-gray-500 dark:text-gray-400">No link provided.</p>
      )}
    </div>
  );
}
